import { render, staticRenderFns } from "./ContaPanel.vue?vue&type=template&id=96f7fa10&"
import script from "./ContaPanel.vue?vue&type=script&lang=js&"
export * from "./ContaPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports